import React from 'react';
import {Link} from 'react-router-dom';
import MailPush from '../../../../Monitoring/Statistics/Widgets/MailPush';

export default () => (
  <div id="statistics-messaging">
    <header className="content-header">
      <h1>
        Statistics
        <small>Messaging</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/mpp/stats/messaging">Messaging</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <MailPush
        app="mppLfp"
        availableFilters={[{value: 'mppLfp', text: 'MPP'}]}
      />
    </section>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/Messaging/index.js